import React from "react";
import { BankHolidayHelper } from "../utils/utils";
import Banner from "./BankHolidayMessage";
import DowntimeBanner from "./DowntimeBanner";

// Endpoint for API, pulled from environment variables
const endpoint = process.env.REACT_APP_API_ENDPOINT;

const Flag = () => {
  const isBankHoliday = BankHolidayHelper() ?? false;

  if (process.env.REACT_APP_ENVIRONMENT === "staging") {
    return <DowntimeBanner />;
  }

  if (process.env.NODE_ENV === "development") {
    return (
      <div className="flag">
        dev mode, endpoint: <a href={endpoint}>{endpoint}</a>
      </div>
    );
  } else if (isBankHoliday === true || isBankHoliday == "true") {
    return <Banner />;
  } else {
    return null;
  }
};

export default Flag;
